import { __assign, __generator } from "tslib";
import { PeekdataError, } from "peekdata-datagateway-api-sdk";
import { all, put, select, take, takeLatest } from "redux-saga/effects";
import { ISelectedNode } from "../models/node";
import { peekdataApi } from "../services/api";
import { IAction } from "./action";
import { actionTypes, changeLimitRowsTo, changeStartWithRow, compatibilityChecked, csvFileLoaded, dataFullLoaded, dataModelNamesLoaded, dataOptimizedLoaded, dimensionsLoaded, filtersLoaded, generateReportRequest, ILoadNodesPayloadRequest, loadDataModelNames, loadDataModelNodes, loadScopeNames, metricsLoaded, reportRequestGenerated, scopeNamesLoaded, selectDataModel, selectLoaded, setFilters, setSelectedDimensions, setSelectedMetrics, } from "./actions";
import { IReportBuilderState } from "./reducers";
import { IScopeNamesState } from "./reducers/scopeNames";
import { getRequestDateRangesFilters, getRequestOptions, getRequestSingleKeysFilters, getRequestSingleValuesFilters, getRequestSortedOptions, } from "../utils/RequestUtils";
import v4 from "uuid/v4";
import { defaultRows } from "../constants/rows";
import { FilterTypes } from "../models/filter";
import { isPeekdataError } from "../utils/ErrorUtils";
function onLoadReportRequest(action) {
    var reportRequest, scopeName, dimensions, metrics, sortings, filters, options, dataModelName, optionsRows, startWithRow, limitRowsTo, selectedDimensions, selectedMetrics, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 16, , 17]);
                reportRequest = action.payload;
                scopeName = reportRequest && reportRequest.scopeName;
                if (!(!reportRequest || !scopeName)) return [3, 2];
                return [4, put(loadScopeNames())];
            case 1:
                _a.sent();
                return [2];
            case 2:
                dimensions = reportRequest.dimensions, metrics = reportRequest.metrics, sortings = reportRequest.sortings, filters = reportRequest.filters, options = reportRequest.options, dataModelName = reportRequest.dataModelName;
                optionsRows = options && options.rows;
                startWithRow = optionsRows && optionsRows.startWithRow;
                limitRowsTo = optionsRows && optionsRows.limitRowsTo;
                return [4, put(loadScopeNames(true))];
            case 3:
                _a.sent();
                return [4, take(actionTypes.scopeNamesLoaded)];
            case 4:
                _a.sent();
                return [4, put(loadDataModelNames(scopeName))];
            case 5:
                _a.sent();
                return [4, take(actionTypes.dataModelNamesLoaded)];
            case 6:
                _a.sent();
                if (!dataModelName) return [3, 15];
                selectedDimensions = getSelectedDimensions(dimensions, sortings);
                selectedMetrics = getSelectedMetrics(metrics, sortings);
                return [4, put(loadDataModelNodes({
                        selectedDataModel: dataModelName,
                        selectedDimensions: selectedDimensions,
                        selectedMetrics: selectedMetrics,
                    }))];
            case 7:
                _a.sent();
                return [4, take(actionTypes.dimensionsLoaded)];
            case 8:
                _a.sent();
                return [4, put(filtersLoaded(filters))];
            case 9:
                _a.sent();
                return [4, put(selectDataModel(null))];
            case 10:
                _a.sent();
                return [4, take(actionTypes.compatibilityChecked)];
            case 11:
                _a.sent();
                return [4, put(changeStartWithRow(startWithRow !== undefined && startWithRow !== null
                        ? Number(startWithRow)
                        : defaultRows.offset))];
            case 12:
                _a.sent();
                return [4, put(changeLimitRowsTo(limitRowsTo !== undefined && limitRowsTo !== null
                        ? Number(limitRowsTo)
                        : defaultRows.limit))];
            case 13:
                _a.sent();
                return [4, put(reportRequestGenerated(reportRequest))];
            case 14:
                _a.sent();
                _a.label = 15;
            case 15: return [3, 17];
            case 16:
                error_1 = _a.sent();
                console.error(error_1);
                return [3, 17];
            case 17: return [2];
        }
    });
}
var getSelectedDimensions = function (dimensions, sortings) {
    return dimensions &&
        dimensions.map(function (value) { return ({
            value: value,
            sorting: getSorting(sortings, value, "dimensions"),
        }); });
};
var getSelectedMetrics = function (metrics, sortings) {
    return metrics &&
        metrics.map(function (value) { return ({
            value: value,
            sorting: getSorting(sortings, value, "metrics"),
        }); });
};
var getSorting = function (sortings, value, key) {
    var sorting = sortings && sortings[key] && sortings[key].find(function (d) { return d.key === value; });
    if (!sorting) {
        return null;
    }
    return sorting && sorting.direction ? sorting.direction : null;
};
function onGenerateReportRequest() {
    var _a, scopeNames, dataModelNames, selectedDimensions, selectedMetrics, filters, limitRowsTo, startWithRow, scopeName, dataModelName, dimensions, metrics, sortedDimensions, sortedMetrics, dateRanges, singleKeys, singleValues, request, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                return [4, select(function (state) { return state; })];
            case 1:
                _a = _b.sent(), scopeNames = _a.scopeNames, dataModelNames = _a.dataModelNames, selectedDimensions = _a.selectedDimensions, selectedMetrics = _a.selectedMetrics, filters = _a.filters, limitRowsTo = _a.limitRowsTo, startWithRow = _a.startWithRow;
                scopeName = scopeNames && scopeNames.selectedScope;
                dataModelName = dataModelNames && dataModelNames.selectedDataModel;
                dimensions = getRequestOptions(selectedDimensions);
                metrics = getRequestOptions(selectedMetrics);
                sortedDimensions = getRequestSortedOptions(selectedDimensions);
                sortedMetrics = getRequestSortedOptions(selectedMetrics);
                dateRanges = getRequestDateRangesFilters(filters);
                singleKeys = getRequestSingleKeysFilters(filters);
                singleValues = getRequestSingleValuesFilters(filters);
                request = {
                    scopeName: scopeName,
                    dataModelName: dataModelName,
                    requestID: v4(),
                    consumerInfo: "Peekdata-Report-Builder-Demo",
                    metrics: metrics,
                };
                if (dimensions && dimensions.length > 0) {
                    request.dimensions = dimensions;
                }
                if (dateRanges && dateRanges.length > 0) {
                    request.filters = __assign(__assign({}, request.filters), { dateRanges: dateRanges });
                }
                if (singleKeys && singleKeys.length > 0) {
                    request.filters = __assign(__assign({}, request.filters), { singleKeys: singleKeys });
                }
                if (singleValues && singleValues.length > 0) {
                    request.filters = __assign(__assign({}, request.filters), { singleValues: singleValues });
                }
                if (sortedDimensions && sortedDimensions.length > 0) {
                    request.sortings = __assign(__assign({}, request.sortings), { dimensions: sortedDimensions });
                }
                if (sortedMetrics && sortedMetrics.length > 0) {
                    request.sortings = __assign(__assign({}, request.sortings), { metrics: sortedMetrics });
                }
                request.options = {
                    rows: {
                        startWithRow: startWithRow !== null && startWithRow !== undefined
                            ? startWithRow.toString()
                            : defaultRows.offset.toString(),
                        limitRowsTo: limitRowsTo !== null && limitRowsTo !== undefined
                            ? limitRowsTo.toString()
                            : defaultRows.limit.toString(),
                    },
                };
                return [4, put(reportRequestGenerated(request))];
            case 2:
                _b.sent();
                return [3, 4];
            case 3:
                error_2 = _b.sent();
                return [3, 4];
            case 4: return [2];
        }
    });
}
function onLoadScopeNames() {
    var scopeNames, error_3, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 6]);
                return [4, peekdataApi.datamodel.getScopeNames()];
            case 1:
                scopeNames = _a.sent();
                return [4, put(scopeNamesLoaded({
                        data: scopeNames,
                        isFetching: false,
                        error: null,
                        errorTimestamp: null,
                    }))];
            case 2:
                _a.sent();
                return [3, 6];
            case 3:
                error_3 = _a.sent();
                return [4, getErrorMessage(error_3)];
            case 4:
                message = _a.sent();
                return [4, put(scopeNamesLoaded({
                        data: null,
                        isFetching: false,
                        error: message,
                        errorTimestamp: new Date(),
                    }))];
            case 5:
                _a.sent();
                return [3, 6];
            case 6: return [2];
        }
    });
}
function onLoadDataModelNames(action) {
    var dataModelNames, error_4, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 6]);
                return [4, peekdataApi.datamodel.getDataModelNames(action.payload)];
            case 1:
                dataModelNames = _a.sent();
                return [4, put(dataModelNamesLoaded({
                        data: dataModelNames,
                        isFetching: false,
                        error: null,
                        errorTimestamp: null,
                    }))];
            case 2:
                _a.sent();
                return [3, 6];
            case 3:
                error_4 = _a.sent();
                return [4, getErrorMessage(error_4)];
            case 4:
                message = _a.sent();
                return [4, put(dataModelNamesLoaded({
                        data: null,
                        isFetching: false,
                        error: message,
                        errorTimestamp: new Date(),
                    }))];
            case 5:
                _a.sent();
                return [3, 6];
            case 6: return [2];
        }
    });
}
function onLoadDimensions(action) {
    var scopeNames, selectedScope, _a, selectedDataModel, selectedDimensions, request, dimensions, error_5, message;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 9]);
                return [4, select(function (state) { return state.scopeNames; })];
            case 1:
                scopeNames = _b.sent();
                selectedScope = scopeNames && scopeNames.selectedScope;
                _a = action.payload, selectedDataModel = _a.selectedDataModel, selectedDimensions = _a.selectedDimensions;
                request = {
                    scopeName: selectedScope,
                    dataModelName: selectedDataModel,
                    metrics: [],
                    dimensions: [],
                };
                return [4, peekdataApi.datamodel
                        .getCompatibleNodes(request)
                        .then(function (response) { return response.dimensions; })];
            case 2:
                dimensions = _b.sent();
                return [4, put(dimensionsLoaded({
                        data: dimensions,
                        isFetching: false,
                        error: null,
                        errorTimestamp: null,
                    }))];
            case 3:
                _b.sent();
                if (!selectedDimensions) return [3, 5];
                return [4, put(setSelectedDimensions(selectedDimensions))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [3, 9];
            case 6:
                error_5 = _b.sent();
                return [4, getErrorMessage(error_5)];
            case 7:
                message = _b.sent();
                return [4, put(dimensionsLoaded({
                        data: null,
                        isFetching: false,
                        error: message,
                        errorTimestamp: new Date(),
                    }))];
            case 8:
                _b.sent();
                return [3, 9];
            case 9: return [2];
        }
    });
}
function onLoadMetrics(action) {
    var scopeNames, selectedScope, _a, selectedDataModel, selectedMetrics, request, metrics, error_6, message;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 9]);
                return [4, select(function (state) { return state.scopeNames; })];
            case 1:
                scopeNames = _b.sent();
                selectedScope = scopeNames && scopeNames.selectedScope;
                _a = action.payload, selectedDataModel = _a.selectedDataModel, selectedMetrics = _a.selectedMetrics;
                request = {
                    scopeName: selectedScope,
                    dataModelName: selectedDataModel,
                    dimensions: [],
                    metrics: [],
                };
                return [4, peekdataApi.datamodel
                        .getCompatibleNodes(request)
                        .then(function (response) { return response.metrics; })];
            case 2:
                metrics = _b.sent();
                return [4, put(metricsLoaded({
                        data: metrics,
                        isFetching: false,
                        error: null,
                        errorTimestamp: null,
                    }))];
            case 3:
                _b.sent();
                if (!selectedMetrics) return [3, 5];
                return [4, put(setSelectedMetrics(selectedMetrics))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [3, 9];
            case 6:
                error_6 = _b.sent();
                return [4, getErrorMessage(error_6)];
            case 7:
                message = _b.sent();
                return [4, put(metricsLoaded({
                        data: null,
                        isFetching: false,
                        error: message,
                        errorTimestamp: new Date(),
                    }))];
            case 8:
                _b.sent();
                return [3, 9];
            case 9: return [2];
        }
    });
}
function onCheckCompatibility() {
    var _a, scopeNames, dataModelNames, selectedDimensions, selectedMetrics, scopeName, dataModelName, dimensions, metrics, compatibilityRequest, compatibility, filtersState, compatibilityDimensions, compatibilityFilters, _i, filtersState_1, filter, isCompatible, _b, compatibilityDimensions_1, dimension, _c, _d, key, error_7, message;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 7, , 10]);
                return [4, select(function (state) { return state; })];
            case 1:
                _a = _e.sent(), scopeNames = _a.scopeNames, dataModelNames = _a.dataModelNames, selectedDimensions = _a.selectedDimensions, selectedMetrics = _a.selectedMetrics;
                scopeName = scopeNames && scopeNames.selectedScope;
                dataModelName = dataModelNames && dataModelNames.selectedDataModel;
                dimensions = getRequestOptions(selectedDimensions);
                metrics = getRequestOptions(selectedMetrics);
                compatibilityRequest = {
                    scopeName: scopeName,
                    dataModelName: dataModelName,
                    requestID: v4(),
                    consumerInfo: "Peekdata-Report-Builder-Demo",
                    dimensions: dimensions,
                    metrics: metrics,
                };
                return [4, peekdataApi.datamodel.getCompatibleNodes(compatibilityRequest)];
            case 2:
                compatibility = _e.sent();
                if (compatibility && (compatibility.message || compatibility.errorCode)) {
                    throw new PeekdataError(compatibility.message, compatibility.errorCode);
                }
                return [4, put(compatibilityChecked({
                        data: compatibility,
                        isFetching: false,
                        error: null,
                        errorTimestamp: null,
                    }))];
            case 3:
                _e.sent();
                return [4, select(function (state) { return state.filters; })];
            case 4:
                filtersState = _e.sent();
                compatibilityDimensions = compatibility.dimensions.map(function (dimension) { return dimension.name; });
                compatibilityFilters = [];
                for (_i = 0, filtersState_1 = filtersState; _i < filtersState_1.length; _i++) {
                    filter = filtersState_1[_i];
                    isCompatible = false;
                    if (!filter.filterType) {
                        compatibilityFilters.push(filter);
                    }
                    else if (filter.filterType === FilterTypes.DateRanges ||
                        filter.filterType === FilterTypes.SingleKeys) {
                        for (_b = 0, compatibilityDimensions_1 = compatibilityDimensions; _b < compatibilityDimensions_1.length; _b++) {
                            dimension = compatibilityDimensions_1[_b];
                            if (filter.key === dimension) {
                                isCompatible = true;
                                break;
                            }
                        }
                        if (isCompatible || !filter.key) {
                            compatibilityFilters.push(filter);
                        }
                    }
                    else if (filter.filterType === FilterTypes.SingleValues) {
                        isCompatible = true;
                        for (_c = 0, _d = filter.keys; _c < _d.length; _c++) {
                            key = _d[_c];
                            if (compatibilityDimensions.indexOf(key) === -1) {
                                isCompatible = false;
                                break;
                            }
                        }
                        if (isCompatible || !filter.keys || filter.keys.length < 1) {
                            compatibilityFilters.push(filter);
                        }
                    }
                }
                return [4, put(setFilters(compatibilityFilters))];
            case 5:
                _e.sent();
                return [4, put(generateReportRequest())];
            case 6:
                _e.sent();
                return [3, 10];
            case 7:
                error_7 = _e.sent();
                return [4, getErrorMessage(error_7)];
            case 8:
                message = _e.sent();
                return [4, put(compatibilityChecked({
                        data: null,
                        isFetching: false,
                        error: message,
                        errorTimestamp: new Date(),
                    }))];
            case 9:
                _e.sent();
                return [3, 10];
            case 10: return [2];
        }
    });
}
function onLoadDataFull(action) {
    var dataFull, error_8, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 6]);
                return [4, peekdataApi.data.getData(action.payload)];
            case 1:
                dataFull = _a.sent();
                return [4, put(dataFullLoaded({
                        data: dataFull,
                        isFetching: false,
                        error: null,
                        errorTimestamp: null,
                    }))];
            case 2:
                _a.sent();
                return [3, 6];
            case 3:
                error_8 = _a.sent();
                return [4, getErrorMessage(error_8)];
            case 4:
                message = _a.sent();
                return [4, put(dataFullLoaded({
                        data: null,
                        isFetching: false,
                        error: message,
                        errorTimestamp: new Date(),
                    }))];
            case 5:
                _a.sent();
                return [3, 6];
            case 6: return [2];
        }
    });
}
function onLoadDataOptimized(action) {
    var dataOptimized, error_9, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 6]);
                return [4, peekdataApi.data.getDataOptimized(action.payload)];
            case 1:
                dataOptimized = _a.sent();
                return [4, put(dataOptimizedLoaded({
                        data: dataOptimized,
                        isFetching: false,
                        error: null,
                        errorTimestamp: null,
                    }))];
            case 2:
                _a.sent();
                return [3, 6];
            case 3:
                error_9 = _a.sent();
                return [4, getErrorMessage(error_9)];
            case 4:
                message = _a.sent();
                return [4, put(dataOptimizedLoaded({
                        data: null,
                        isFetching: false,
                        error: message,
                        errorTimestamp: new Date(),
                    }))];
            case 5:
                _a.sent();
                return [3, 6];
            case 6: return [2];
        }
    });
}
function onLoadCsvFile(action) {
    var file, error_10, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 6]);
                return [4, peekdataApi.data.getCSV(action.payload)];
            case 1:
                file = _a.sent();
                return [4, put(csvFileLoaded({
                        data: file,
                        isFetching: false,
                        error: null,
                        errorTimestamp: null,
                    }))];
            case 2:
                _a.sent();
                return [3, 6];
            case 3:
                error_10 = _a.sent();
                return [4, getErrorMessage(error_10)];
            case 4:
                message = _a.sent();
                return [4, put(csvFileLoaded({
                        data: null,
                        isFetching: false,
                        error: message,
                        errorTimestamp: new Date(),
                    }))];
            case 5:
                _a.sent();
                return [3, 6];
            case 6: return [2];
        }
    });
}
function onLoadSelect(action) {
    var selectStr, error_11, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 6]);
                return [4, peekdataApi.data.getQuery(action.payload)];
            case 1:
                selectStr = _a.sent();
                return [4, put(selectLoaded({
                        data: selectStr,
                        isFetching: false,
                        error: null,
                        errorTimestamp: null,
                    }))];
            case 2:
                _a.sent();
                return [3, 6];
            case 3:
                error_11 = _a.sent();
                return [4, getErrorMessage(error_11)];
            case 4:
                message = _a.sent();
                return [4, put(selectLoaded({
                        data: null,
                        isFetching: false,
                        error: message,
                        errorTimestamp: new Date(),
                    }))];
            case 5:
                _a.sent();
                return [3, 6];
            case 6: return [2];
        }
    });
}
function getErrorMessage(error) {
    var translations, apiErrors, translation;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!isPeekdataError(error)) return [3, 2];
                return [4, select(function (state) { return state.translations; })];
            case 1:
                translations = _a.sent();
                apiErrors = translations && translations.apiErrors;
                translation = apiErrors && apiErrors[error.code];
                return [2, translation || error.toString()];
            case 2: return [2, error.toString()];
        }
    });
}
export function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, all([
                    takeLatest(actionTypes.loadReportRequest, onLoadReportRequest),
                    takeLatest(actionTypes.generateReportRequest, onGenerateReportRequest),
                    takeLatest(actionTypes.loadScopeNames, onLoadScopeNames),
                    takeLatest(actionTypes.loadDataModelNames, onLoadDataModelNames),
                    takeLatest(actionTypes.loadDataModelNodes, onLoadDimensions),
                    takeLatest(actionTypes.loadDataModelNodes, onLoadMetrics),
                    takeLatest(actionTypes.selectOption, onCheckCompatibility),
                    takeLatest(actionTypes.unselectOption, onCheckCompatibility),
                    takeLatest(actionTypes.loadDataOptimized, onLoadDataOptimized),
                    takeLatest(actionTypes.loadDataFull, onLoadDataFull),
                    takeLatest(actionTypes.loadCsvFile, onLoadCsvFile),
                    takeLatest(actionTypes.loadSelect, onLoadSelect),
                ])];
            case 1:
                _a.sent();
                return [2];
        }
    });
}
